import modalStyles from './modal';

/*******************************************************************************
Custom Modal Object
Allows 2 types of modals. Both are triggered by adding the class 'modal__trigger'
to an HTML element. Then to create the specific type of modal, you add one of 2
data attributes.

1. Youtube modals
    For Youtube modals, you add a data-video-id that contains a YouTube video id
    to the trigger element and when clicked, a modal will open with that video
    embedded in it.

    Example: <a href="#" class="primary-feature__video-id btn btn-video-player modal__trigger" data-video-id="Q9upzzIgm_c"><div class="arrow-right"></div></a>

2. Content Modals
    For Content modals, you create a dom element on the page that contains the
    content you want to appear in the modal.  If you add the class "modal__content"
    to that element, it will be set to display none, but whatever method you
    want to hide it is fine. Then on the trigger you add a data-content-query-selector
    attribute to it that contains the css selector needed to identify modal__content
    element. When you click the trigger it will copy the contents of the modal__content
    innerHTML to the modal and will display that when the modal opens.

    Example: <a class="primary-feature__cta btn btn-primary modal__trigger" data-content-query-selector="#modal-example">Modal Me</a>
    <div id="modal-example" class="modal__content">Hey, I'm modal content</div>

*******************************************************************************/
export default class Modal {
  constructor() {
    this.insertModalMarkUp();

    this.attachTriggers();

    this.triggerModal = this.triggerModal.bind(this);
    this.hideModal = this.hideModal.bind(this);
  }

  insertModalMarkUp = () => {
    const modalBackground = document.createElement('div');
    modalBackground.innerHTML = '<div class="modal__holder" id="pods-modal__holder"><div class="modal__closer"><div class="modal__closer-bar"></div><div class="modal__closer-bar"></div></div><div class="modal__content-holder"></div></div>';
    document.body.appendChild(modalBackground).className = 'modal__background';

    this.modalHolder = document.getElementById('pods-modal__holder');
  }

  attachTriggers = () => {
    document.querySelector('.modal__closer').addEventListener("click", this.hideModal);

    [...document.body.querySelectorAll('.modal__trigger')].map( (trigger)=>{
      trigger.addEventListener("click", (e)=> this.triggerModal(e));
    })
  }

  triggerModal = (element) => {
    element.preventDefault();
    let triggerEl = element.currentTarget;

    this.modalHolder.classList.remove('modal__youtube_holder');

    if(element.currentTarget.getAttribute('data-video-id')) {
      this.populateVideoModal(element.currentTarget.getAttribute('data-video-id'));
    } else if (element.currentTarget.getAttribute('data-content-query-selector')){
      let contentElement = document.querySelector(element.currentTarget.getAttribute('data-content-query-selector'));
      this.populateContentModal(contentElement);
    }
    else if(element.currentTarget.getAttribute('data-video-url')){
    this.populateNBFVideoModal(element.currentTarget.getAttribute('data-video-url'));
    } 
  }

  populateVideoModal = (videoID) => {
    let iframeMarkup = "<iframe width='100%' class='modal__youtube-iframe' src='https://www.youtube.com/embed/" + videoID + "?rel=0&showinfo=0' frameborder='0' allow='encrypted-media' allowfullscreen></iframe>";

    this.modalHolder.querySelector('.modal__content-holder').innerHTML = iframeMarkup;

    this.modalHolder.classList.add('modal__youtube_holder');

    this.showModal(true);
  }
  populateNBFVideoModal = (videoID) => {
    let iframeMarkup = "<iframe width='100%' class='modal__youtube-iframe' src='" + videoID + "?rel=0&showinfo=0' frameborder='0' allow='encrypted-media' allowfullscreen></iframe>";

    this.modalHolder.querySelector('.modal__content-holder').innerHTML = iframeMarkup;
    if (videoID.includes("youtu")){
      this.modalHolder.classList.add('youtube');
    }
     this.modalHolder.classList.add('modal__nbfvideo_holder');
    
    this.showModal(true);
  }

  populateContentModal = (contentElement) => {
    if (contentElement) {
      this.modalHolder.querySelector('.modal__content-holder').innerHTML = contentElement.innerHTML;
      this.showModal();
    }
  }

  populateContentModalWithMarkup = (markup) => {
    this.modalHolder.querySelector('.modal__content-holder').innerHTML = markup;
    this.showModal();
  }

  showModal = (isYouTubeModal = false) => {
    document.body.classList.add('modal__open');
    if(isYouTubeModal) {
      this.modalHolder.querySelector('.modal__youtube-iframe').style.height = '${ this.modalHolder.offsetWidth * .5625 }px';
    }
  }

  hideModal = () => {
    document.body.classList.remove('modal__open');
    this.modalHolder.querySelector('.modal__content-holder').innerHTML = '';
  }
}
